<template>
  <i-button @click="$emit('click')" :type="type" :shape="shape" :style='editorStyle' :id="id">{{ innerText }}</i-button>
</template>
<script>
const component = {
  name: 'hex-button',
  props: {
    type: String,
    shape: String,
    st: Object,
    innerText: String,
    id: String
  },
  data() {
    return {
      editorStyle: process.env.MODE === 'editor' ? this.st : this.st
    }
  }
}
// 区分editor和实际打包， build之后的lib不打包
if (process.env.MODE === 'editor') {
  component.define = require('./define')
}
export default component
</script>



// WEBPACK FOOTER //
// index.vue?3b8e9b41